module.exports = __webpack_public_path__ + "img/freewave2_05.29a77dca.jpg";